import React, { useEffect } from "react";
import { Grid, Card, Typography, Box, Button, FormControl, Stack, MenuItem, InputLabel, Select } from "@mui/material";
import { localizedName } from "../../helper/LangHelper";
import { timeToDateStr } from "../../helper/StringHelper";
import { useNavigate } from "react-router-dom";
// import { MemberApi } from "../api/MemberApi";
// import { useSelector, useDispatch } from "react-redux";
// import { memberID, updateAuthState } from "../reducers/userSlice";
import CommonDataSelection from "../../components/common/CommonDataSelection/CommonDataSelection";


function getDefaultEventID(eventList) {
    if (eventList.length > 0) {
        return eventList[0].id;
    }

    return 0;
}

function getEventFromList(eventList, eventID) {
    for (let event of eventList) {
        if (event.id === eventID) {
            return event;
        }
    }

    return null;
}

function getCurrentSchoolYear() {
    // Month: 9-12: currentYear
    // Month: 1-8: currentYear - 1
    const now = new Date();
    const month = now.getMonth() + 1;
    let year = now.getFullYear();

    if (month >= 9) {
        return year;
    } else {
        return year - 1;
    }
}

function generateYearOptionList() {
    const currentYear = getCurrentSchoolYear();
    const years = [];
    for (let i = 0; i < 5; i++) {
        const year = currentYear - i;
        const caption = `${String(year).slice(2)}/${String(year + 1).slice(2)}`;
        years.push({ caption, id: year });
    }
    return years;
}

function generateSemesterOptionList() {
    return [
        { 'caption': '上學期', 'id': 'semester1' },
        { 'caption': '下學期', 'id': 'semester2' },
        { 'caption': '全學年', 'id': 'semester' },
    ];
}

function generateModeOptionList() {
    return [
        { 'caption': '班際', 'id': 'class' },
        { 'caption': '個人', 'id': 'student' },
    ];
}

export default function SchoolLeaderboardQueryForm({ onQuery }) {

    const yearOptionList = generateYearOptionList();
    const semesterOptionList = generateSemesterOptionList();
    const modelOptionList = generateModeOptionList();


    // Query Data 
    const [year, setYear] = React.useState(2025);
    const [dateRangeType, setDateRangeType] = React.useState('semester');
    const [mode, setMode] = React.useState('student');



    const onYearChanged = (evt) => {
        setYear(evt.target.value);
    };

    const onDateRangeTypeChanged = (evt) => {
        setDateRangeType(evt.target.value);
    }

    const onModeChanged = (evt) => {
        setMode(evt.target.value);
    };

    const onQueryClicked = () => {
        if (onQuery != null) {
            onQuery({
                mode,
                filters: {


                    year, dateRangeType
                }
            });
        }
    }

    return (<Card>
        <Box sx={{ padding: 2 }}>
            {/* <Typography variant="h5">Event Leaderboard</Typography> */}
            {/* {eventSelection} */}
            <Grid container spacing={2}>
                <Grid item xs={2} sm={2}>
                    <CommonDataSelection
                        itemKey="year"
                        label="學年"
                        value={year}
                        dataList={yearOptionList}
                        captionFn={(item) => item.caption}
                        onChange={onYearChanged}
                    />
                </Grid>
                <Grid item xs={2} sm={2}>
                    <CommonDataSelection
                        itemKey="dateRangeType"
                        label="時段"
                        value={dateRangeType}
                        dataList={semesterOptionList}
                        captionFn={(item) => item.caption}
                        onChange={onDateRangeTypeChanged}
                    />
                </Grid>
                <Grid item xs={2} sm={2}>
                    <CommonDataSelection
                        itemKey="mode"
                        label="模式"
                        value={mode}
                        dataList={modelOptionList}
                        captionFn={(item) => item.caption}
                        onChange={onModeChanged}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Button variant="contained" onClick={onQueryClicked}>查詢</Button>
                </Grid>

            </Grid>

        </Box>
        {/* <pre>
            Year: {year} dateRangeType: {dateRangeType}    
        </pre> */}
    </Card>);
}